import { Modal } from "react-bootstrap";
import { COMPANY_PROFILE_LIST } from "../../../../core/dictionary/global";

const CompanyProfileEmailAlertModal = ({ show, handleClose, company_name, addToFavourite }) => {
  return (
    <div>
      <Modal centered show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Set monthly email alert for <span className="text-capitalize">{company_name}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>Unlock the full potential of our alerting system to gain actionable insights on your subscribed datasets.</p>
            <hr />
            <p className="company-email-modal-text">Get access to rankings and valuable insights measurable by Shipment Value (USD), including updates on -</p>
            <div>
              {COMPANY_PROFILE_LIST.map((item) => (
                <div className="mt-2">
                  <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687520084/intel/icons/verified_irsyky.svg" />
                  <span className="company-email-modal-text">{item}</span>
                </div>
              ))}
            </div>
            {/* <p className="text-center">Didn’t receive email? <button type="button" className="btn btn-link trademo-link" onClick={sendVerificationEmail}>Resend</button> </p> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={handleClose} className="btn btn-outline-secondary trademo-outline-btn btn-sm py-2">
            Cancel
          </button>
          <button onClick={addToFavourite} className="btn btn-primary trademo-new-btn">
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CompanyProfileEmailAlertModal;
